"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeDemo_de_de = void 0;
function backofficeDemo_de_de() {
    return {
        "backoffice.demo.errors.alreadyregisteredemail": "Diese E-Mail Adresse ist bereits registriert. Bitte melden Sie sich stattdessen an und erstellen Sie ein neues Projekt. Während der Erstellung können Sie Demo Daten auswählen, welche dann bei der Projekterstellung importiert werden."
    };
}
exports.backofficeDemo_de_de = backofficeDemo_de_de;
